import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  AutoCompleteModule,
  ButtonModule,
  CheckboxModule,
  DataTableModule,
  DialogModule,
  DropdownModule,
  InputTextModule,
  TooltipModule
} from 'primeng/primeng';
import { TranslateModule } from '@ngx-translate/core';

import { ApiValidationModule } from 'app/shared/api-validation';
import { UserRoutingModule } from './user-routing.module';
import { LoginComponent } from './login/login.component';
import { UserComponent } from './user.component';
import { UserFormComponent } from './user-form/user-form.component';
import { UserService } from './user.service';
import { UserRepository } from './user.repository';
import { UserResolve } from './user.resolve';
import { AutocompleteModule } from 'app/shared/autocomplete';
import { ResetPasswordModule } from './reset-password/reset-password.module';
import { UserSharedModule } from './user-shared/user-shared.module';
import { CoachModule } from './coach/coach.module';
import { ParticipantModule } from './participant/participant.module';
import { WorkRecordModule } from './work-record/work-record.module';
import { UserImportModule } from 'app/import/user-import.module';
import { ErrorDisplayModule } from 'app/shared';
import { SessionRepository } from 'app/session/session.repository';
import { SurveyRepository } from 'app/survey/survey.repository';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    ButtonModule,
    DataTableModule,
    DialogModule,
    InputTextModule,
    CheckboxModule,
    TranslateModule,
    AutocompleteModule,
    ResetPasswordModule,
    UserSharedModule,
    DropdownModule,
    CoachModule,
    ParticipantModule,
    WorkRecordModule,
    UserImportModule,
    UserRoutingModule,
    TooltipModule,
    ApiValidationModule,
    ErrorDisplayModule
  ],
  declarations: [
    LoginComponent,
    UserComponent,
    UserFormComponent
  ],
  providers: [
    SessionRepository,
    SurveyRepository,
    UserRepository,
    UserService,
    UserResolve
  ],
  exports: [
    LoginComponent,
    UserComponent
  ]
})
export class UserModule { }



// WEBPACK FOOTER //
// /dist/src/app/user/user.module.ts